import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import '@/index.css';
import App from '@/App';
import { store } from '@/store';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://41601cdc9742f9262fbb83728ac51094@o4510790764462080.ingest.us.sentry.io/4511022119583744",
    sendDefaultPii: true,
    tracesSampleRate: 0.1,       // capture 10% of transactions for performance
    sampleRate: 1.0,             // capture 100% of errors (reduce if too noisy)
    ignoreErrors: [
      // Browser/network noise not worth tracking
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Network request failed',
      'NetworkError',
      'Failed to fetch',
      'Load failed',
      /^ChunkLoadError/,         // lazy-load failures (usually transient)
      /^AbortError/,
    ],
    beforeSend(event) {
      // Drop errors from browser extensions
      const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
      if (frames.some(f => f.filename?.startsWith('chrome-extension://') || f.filename?.startsWith('moz-extension://'))) {
        return null;
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
